import { css } from "@emotion/react";

// && is to increase specificity
const plansConfigBar = css`
  margin: 30px 0;
  display: flex;
  justify-content: space-between;

  @media (max-width: 470px) {
    flex-direction: column;
    gap: 20px;

    && > * {
      width: 100%;
    }
  }
}
`;

type Props = {
  children: React.ReactNode;
};

export const PlansConfigBar = ({ children }: Props) => {
  return <div css={plansConfigBar}>{children}</div>;
};
